import { CSSProperties } from 'react';
import {
  COLORS,
  CONTENT_COLUMN,
  FONTS,
  META,
  SIGNATURE_LAYER,
  glass,
} from '../../globalStyles';

const HEADER_CONTENT_HEIGHT = '2.25rem';

const HEADER_HEIGHT = `calc(${HEADER_CONTENT_HEIGHT} + 2 * var(--header-pad-y) + 1px)`;

export const styles: Record<string, CSSProperties> = {
  page: {
    minHeight: '100vh',
    paddingTop: HEADER_HEIGHT,
    color: COLORS.text,
  },
  signature: {
    ...SIGNATURE_LAYER,
    opacity: 'var(--signature-opacity)',
  },
  header: {
    ...glass('var(--header-glass)', 10),
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    borderBottom: `1px solid ${COLORS.border}`,
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    minHeight: `calc(${HEADER_CONTENT_HEIGHT} + 2 * var(--header-pad-y))`,
    padding: 'var(--header-pad-y) var(--header-pad-x)',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.75rem',
  },
  navLink: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    fontWeight: 500,
    color: COLORS.muted,
    textDecoration: 'none',
  },
  footer: {
    borderTop: `1px solid ${COLORS.borderStrong}`,
    marginTop: '2rem',
  },
  footerInner: {
    ...CONTENT_COLUMN,
    padding: '2.5rem 6vw 3rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  },
  footerRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem 2rem',
  },
  maker: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.7rem',
    fontFamily: FONTS.novaeon,
    fontSize: '0.9rem',
    color: COLORS.text,
    textDecoration: 'none',
  },
  footerLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.75rem 1.5rem',
  },
  footerLink: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    color: COLORS.muted,
    textDecoration: 'none',
  },
  copyright: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.label,
  },
  recaptcha: {
    ...META,
    fontSize: '0.62rem',
    lineHeight: 1.7,
    textTransform: 'none',
    letterSpacing: '0.04em',
    color: COLORS.faint,
  },
  recaptchaLink: {
    color: COLORS.muted,
  },
};
